import { Router } from '@angular/router';
import { SettingsService } from './../services/setting-service/setting.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout',
  standalone: false,
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent  implements OnInit{
  opened = true;
  menu = [
    {
      route: '/dashboard',
      icon: 'dashboard',
      label: 'Dashboard',
      hide:false,
    },
    {
      route: '/doctor',
      icon: 'medical_services',
      label: 'Gestão de Médicos',
      hide:false,
    },
    {
      route: '/products',
      icon: 'medication',
      label: 'Produtos',
      hide:false,
    },
      {
      route: '/wishlist',
      icon: 'favorite_border',
      label: 'Lista de Desejos',
      hide: false,
    },
    {
      route: '/rescues',
      icon: 'list_alt',
      label: 'Pedidos',
      hide:false,
    },
    {
      route: '/dispatches',
      icon: 'mail',
      label: 'Disparos Pontuais',
      hide:false,
    },
    {
      route: '/communications-history',
      icon: 'history',
      label: 'Histórico',
      hide:false,
    }
  ]

  constructor(public settingsService: SettingsService,private router:Router) {}

  ngOnInit() {
    const api = this.settingsService.configUso.urlApiPadrao || '';
    if (api.startsWith('https://api.pdag.chiesi.com.br/') || api.startsWith('https://api.dev.pdag.chiesi.com.br/') || api.startsWith('http://localhost:3014/')) {
      this.menu.push({route:'/consent-alerts',icon:'notifications_active',label:'Alertas de termos',hide:false});
    }
  }

  logout(){
    localStorage.removeItem('USER_DATA');
    this.router.navigate(['/login']);
  }


}
